<template>
  <el-dialog
    class="comp-container"
    :visible.sync="visible"
    width="30%"
    top="30vh"
    custom-class="comfirm-remove-dialog"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="error-content">
      <img src="@saas/pages/assets/images/live/error.png" alt="" />
      <div class="error-message">{{ errorMessage }}</div>
    </div>
    <div class="error-footer">
      <el-button @click="handleClose"> 取消 </el-button>
      <el-button type="primary" @click="handleRefresh"> 刷新 </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { uploadLiveLog } from "@saas/components/src/utils/log";

export default {
  props: {},
  data() {
    return {
      visible: false,
      isElectron: !!window.isElectron,
    };
  },
  watch: {
    showCdnStreamError: {
      handler(newVal) {
        this.visible = newVal.visible;
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState("live", ["showCdnStreamError"]),
    errorMessage() {
      return this.showCdnStreamError?.info?.errorMessage || "-";
    },
  },
  methods: {
    ...mapMutations("live", ["setShowCdnStreamError"]),
    handleRefresh() {
      window.location.reload();
      uploadLiveLog({
        message: "用户点击刷新",
        level: "info",
        tag: "userAction",
        extra: {
          component: "CdnStreamError",
          action: "click_cdn_stream_error_refresh",
        },
      });
    },
    handleClose() {
      this.visible = false;
      this.setShowCdnStreamError({
        visible: false,
        info: {},
      });
      uploadLiveLog({
        message: "用户点击取消",
        level: "info",
        tag: "userAction",
        extra: {
          component: "CdnStreamError",
          action: "click_cdn_stream_error_close",
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container ::v-deep {
  .comfirm-remove-dialog {
    width: 327px !important;
    background: #18181b;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
      0px 1px 3px 0px rgba(0, 0, 0, 0.1);
    border-radius: 12px 12px 12px 12px;
    border: 1px solid rgba(229, 231, 235, 0.04);
    padding: 16px;

    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      font-size: 14px;
      color: #a1a1aa;

      text-align: center;
      .error-content {
        max-width: 300px;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        img {
          width: 24px;
          height: 24px;
          margin-right: 8px;
        }
        .error-message {
          text-align: left;
        }
      }

      .error-footer {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-button {
          flex: 1;
          background: #165dff;
          border-radius: 12px 12px 12px 12px;
          border: none;
          font-weight: 500;
          font-size: 14px;
          color: #ecedee;
          &.el-button--primary {
            background: #165dff;
            &:hover {
              background: #165dff !important;
            }
            &:focus {
              background: #165dff !important;
            }
          }
          &.el-button--default {
            background: #3f3f46;
          }
        }
      }
    }
    .el-dialog__footer {
      display: none;
    }
  }
}
</style>
